import { useFormikContext } from 'formik';

import { ErrorField } from '@/components/error-field';
import { RequiredLabel } from '@/components/required-label';
import { Field } from '@/components/ui/field';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { PhoneInput } from '@/components/ui/phone-input';

import type { UpdateUserProfileFormValues } from '@/schemas/user.schema';

import { useFormikError } from '@/lib/error';

export const UpdateProfileForm = () => {
  const { getFieldProps, setFieldValue } = useFormikContext<UpdateUserProfileFormValues>();

  const hasError = useFormikError();

  return (
    <div className="flex flex-col gap-4 px-4 py-4 w-full">
      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Field aria-invalid={hasError('first_name')}>
            <RequiredLabel htmlFor="firstName">First name</RequiredLabel>
            <Input
              id="firstName"
              {...getFieldProps('first_name')}
              aria-invalid={hasError('first_name')}
            />
            <ErrorField name="first_name" />
          </Field>
        </div>
        <div className="space-y-2">
          <Field aria-invalid={hasError('last_name')}>
            <RequiredLabel htmlFor="lastName">Last name</RequiredLabel>
            <Input
              id="lastName"
              {...getFieldProps('last_name')}
              aria-invalid={hasError('last_name')}
            />
            <ErrorField name="last_name" />
          </Field>
        </div>
      </div>
      <div className="space-y-2">
        <Field aria-invalid={hasError('phone_number')}>
          <Label htmlFor="phone">Phone number</Label>
          <PhoneInput
            id="phone"
            {...getFieldProps('phone_number')}
            onChange={value => setFieldValue('phone_number', value)}
            aria-invalid={hasError('phone_number')}
          />
          <ErrorField name="phone_number" />
        </Field>
      </div>
    </div>
  );
};
